import * as React from 'react';

const SvgWhatsapp = (props) => (
  <svg
    width={40}
    height={40}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <circle
      cx={20}
      cy={20}
      r={19}
      fill='#65D072'
      stroke='#fff'
      strokeWidth={2}
    />
    <path
      d='M25.897 14.107a8.29 8.29 0 0 0-6.586-2.412c-3.341.268-6.27 2.592-7.25 5.797-.7 2.29-.405 4.68.735 6.656l-1.08 3.585a.46.46 0 0 0 .558.576l3.753-1.006a8.317 8.317 0 0 0 3.978 1.014h.003c3.496 0 6.726-2.139 7.844-5.451 1.088-3.23.283-6.52-1.955-8.76Zm-1.816 8.855c-.173.486-1.022.954-1.404.988-.381.035-.739.173-2.495-.52-2.115-.833-3.45-3-3.553-3.14-.104-.138-.85-1.127-.85-2.15s.538-1.527.73-1.734a.764.764 0 0 1 .554-.26c.139 0 .278 0 .399.005.148.006.312.013.468.36.185.41.589 1.44.64 1.543.052.104.087.226.018.364-.069.139-.104.225-.207.347-.105.122-.219.27-.312.364-.104.104-.212.217-.092.424.122.209.539.89 1.157 1.44.795.709 1.464.928 1.672 1.033.209.104.33.087.451-.053.122-.138.52-.606.659-.815.138-.208.277-.173.468-.104.19.07 1.213.573 1.42.677.21.104.348.156.4.242.05.086.05.503-.123.989Z'
      fill='#fff'
    />
  </svg>
);

export default SvgWhatsapp;
